export default __webpack_public_path__ + "static/media/e2.1791f8ec.webp";